var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostcoProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e36a85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47965,
    stopColor: "#e31938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#e31837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e1837"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.36389,48.17163c.36646.21155.81787.21155,1.18433,0l16.11841-9.30554c.78961-.45587.78961-1.59552,0-2.05139l-5.6098-3.23883-18.48682,10.67346,6.79388,3.9223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.24591,38.86615l5.1319,2.96283,18.48706-10.67334-6.31635-3.64673c-.36646-.21161-.81793-.21161-1.18439,0l-16.11823,9.30585c-.78961.45587-.78955,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.94897,63.14972l16.18451,9.34412c.76733.44305,1.7265-.11072,1.7265-.99677v-18.68817c0-.41125-.21936-.7912-.5755-.99683l-6.8717-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.7674-.44305-1.72656.11072-1.72656.99683v18.68835c0,.41119.21936.7912.5755.99677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.99915,62.33722c-1.2652,6.33704,3.9964,11.26001,11.98633,11.26001,1.82111,0,5.65607-.26569,7.42358-.88409l1.95728-8.31293c-1.88806,1.2674-3.90564,2.06299-6.24695,2.06299-3.04755,0-5.30927-1.8866-4.82104-4.33282.48224-2.4165,3.35492-4.33136,6.40253-4.33136,2.30408,0,4.14227,1.03149,5.53693,2.23267l1.38873-8.45355c-2.03766-.5954-4.35144-.91321-6.65552-.91321-8.21393,0-15.67102,5.18799-16.97186,11.6723Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostcoProductsScraper);
export default __webpack_public_path__ + "static/media/costco-products-scraper.26468abc4e4ec9e9c286be9adac4098d.svg";
export { ForwardRef as ReactComponent };